import DownloadApplicationSection from "../Components/downloadApplicationSection";
import RequestDemoSection from "../Components/requestDemoSection";

const TermsOfUse = () => {
    return (
        <>
            <div style={{
                width: "100%",
                minHeight: "50vh",
                backgroundImage: "url('/TermsOfUseBg.jpg')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }} className="flex justify-content-start align-items-center px-4 md:px-8" >
                <p className="m-0" style={{ color: "#29345E", lineHeight: "1.2", fontSize: "3.25rem", fontWeight: 700 }} >
                    Terms Of Use
                </p>
            </div>
            <div className="flex flex-wrap justify-content-center md:justify-content-start align-items-start py-5 px-4 md:px-8">
                <div className="flex flex-column justify-content-center align-items-start gap-4" >
                    <p className="flex flex-wrap m-0" style={{ color: "#2D3967", fontSize: "1.375rem", fontWeight: 700 }} >
                        <span className="mr-2">Who can use</span> <span className="flex align-items-center gap-1">Mobithera<span style={{fontSize: "1.25rem", marginTop: "-0.5rem"}}>™</span></span>
                    </p>
                    <p className="m-0 text-xl md:text-lg" style={{ color: "#727A99" }}>
                        Mobithera provides an advanced digital platform designed to facilitate rehabilitation, exercise monitoring, and patient engagement for individual users, healthcare professionals, and clinics. These Terms of Use apply to your access and use of both the website and the Mobithera mobile application.
                        By using any part of our services, you agree to comply with all applicable regulations, professional guidelines, and the terms outlined in this document. The Terms of Use govern your rights, responsibilities, and restrictions, including data collection and storage practices, account security, permissible activities, and limitations of liability.
                        For comprehensive information on our policies, permitted uses, disclaimers, and your legal obligations, please review the complete Terms of Use document here:
                        <br />
                        <br />
                        <a href="#" style={{ color: "#2D3967" }}>View Full Terms of Use</a>
                    </p>
                </div>
            </div>
            <RequestDemoSection />
            <DownloadApplicationSection />
        </>
    )
}

export default TermsOfUse;
